
import { Question } from "@/interfaces/Question";
import Vue from "vue";
import store from "@/store";

export default Vue.extend({
  name: "question-file-upload",
  props: {
    value: Object,
    showerror: Boolean,
    previewMode: Boolean,
    readonly: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      question: null as Question | null,
      localFile: null as File | null,
      previewUrl: null as string | null,
      fileType: null as string | null,
      fileName: null as string | null,
      isDragging: false,
      base64: null as string | null,
    };
  },
  created() {
    this.importData(this.value);
  },
  watch: {
    value(newVal) {
      this.importData(newVal);
    },
    async base64(newVal) {
      if (this.question == null) return;
      if (newVal && !newVal.includes("http") && !this.previewMode) {
        var url = await store.dispatch("SaveQuestionsFile", { Base64: this.base64, FileType: this.fileType });
        this.base64 = url;
        this.previewUrl = url;
        this.question.selectedAnswers = [{ answerText: this.base64, followUpQuestionID: 0, order: 0, answerID: 0 }];
        return;
      }
    },
  },
  computed: {
    isImage() {
      return this.fileType && ["png", "jpg", "jpeg", "gif"].includes(this.fileType.toLowerCase());
    },
    isPdf() {
      return this.fileType && this.fileType.toLowerCase() === "pdf";
    },
  },
  methods: {
    triggerFileInput() {
      (this.$refs.fileInput as HTMLInputElement).click();
    },
    handleFileChange(event: Event) {
      const input = event.target as HTMLInputElement;
      if (input.files && input.files[0]) {
        const file = input.files[0];
        this.localFile = file;
        this.fileName = file.name;
        this.fileType = file.name.split(".").pop() || "unknown";
        const reader = new FileReader();
        reader.onload = (e) => {
          this.base64 = e.target?.result as string;
          this.previewUrl = this.base64;
        };
        reader.readAsDataURL(file);
      }
    },
    onDragOver() {
      this.isDragging = true;
    },
    onDragLeave() {
      this.isDragging = false;
    },
    onDrop(event: DragEvent) {
      this.isDragging = false;
      const file = event.dataTransfer?.files[0];
      if (file) {
        this.localFile = file;
        this.fileName = file.name;
        this.fileType = file.name.split(".").pop() || "unknown";
        const reader = new FileReader();
        reader.onload = (e) => {
          this.base64 = e.target?.result as string;
          this.previewUrl = this.base64;
        };
        reader.readAsDataURL(file);
      }
    },
    btnChangeFile_click() {
      this.localFile = null;
      this.previewUrl = null;
      this.fileType = null;
      this.fileName = null;
      this.base64 = null;
    },
    importData(newVal: Question) {
      this.question = newVal;
      const answer = this.question.selectedAnswers && this.question.selectedAnswers.length > 0 ? this.question.selectedAnswers[0].answerText : null;
      this.previewUrl = answer;
      this.base64 = answer;
      if (answer) {
        this.fileType = answer.split(".").pop() || "unknown";
        this.fileName = answer.split("/").pop() || "Uploaded File";
      }
    },
  },
  components: {},
});
